export const EXSBREASON_CREATE_RESET = 'EXSBREASON_CREATE_RESET'
export const EXSBREASON_CREATE_SET_CREATED = 'EXSBREASON_CREATE_SET_CREATED'
export const EXSBREASON_CREATE_SET_ERROR = 'EXSBREASON_CREATE_SET_ERROR'
export const EXSBREASON_CREATE_SET_VIOLATIONS = 'EXSBREASON_CREATE_SET_VIOLATIONS'
export const EXSBREASON_CREATE_TOGGLE_LOADING = 'EXSBREASON_CREATE_TOGGLE_LOADING'
